import Rule from './Rule.jsx';

export default Rule;



// WEBPACK FOOTER //
// ./src/pages/Search/Main/FilterBar/FilterGroupCollection/Panels/PanelLarge/Rule/index.js